import { COLUMN_NAME } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

const CardTypeNameColumns : TableColumn[] =  [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    }
];

export default CardTypeNameColumns;
